import { unpackXrayDots, type XrayDots } from "@bfly/engine";
import { decodeGzip } from "@bfly/engine/data";
import xrayUrl from "../assets/data/xray.bin.gz?url";

/** Where the portrait gets its X-ray: `allowed` settles once the page lets it load (after the
    first view), and `load()` downloads it once for the element's whole life. */
export interface XraySource {
  allowed: Promise<void>;
  load(): Promise<XrayDots>;
}

/** Downloads the X-ray's dots and moves them onto the face. */
export async function loadXrayDots(): Promise<XrayDots> {
  const response = await fetch(xrayUrl);
  if (!response.ok) throw new Error(`X-ray: request failed with ${response.status}`);
  return unpackXrayDots(new Uint8Array(await decodeGzip(await response.arrayBuffer())));
}
